/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './button-primary-wide.scss';

class ButtonPrimaryWide extends Component {
    // constructor(props) {
    //     super(props);
    // }

    render() {
        const { label, disabled, onClick } = this.props;

        return (
            <button type="button" className="button-primary-wide" disabled={disabled} onClick={onClick}>
                <span className="button-primary-wide__label" dangerouslySetInnerHTML={{ __html: label }} />
            </button>
        );
    }
}

ButtonPrimaryWide.propTypes = {
    label: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func
};

ButtonPrimaryWide.defaultProps = {
    label: '',
    disabled: false,
    onClick: () => {}
};

export default ButtonPrimaryWide;
